module.exports = __webpack_public_path__ + "static/media/design.027ad5a1.png";